import cx from 'classnames';
import T from 'components/common/text/T';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import ProjectModelViewer from './clinic/ProjectModelViewer';

interface ProjectFileViewerProps {
  hasViewer: boolean;
  viewModelFile: {
    value: any;
    onChange: (e: any) => void;
    setValue: React.Dispatch<any>;
  };
  htmlViewerRef: React.MutableRefObject<HTMLIFrameElement | null>;
  viewHtmlFile: {
    value: any;
    onChange: (e: any) => void;
    setValue: React.Dispatch<any>;
  };
  viewImageFile: {
    value: any;
    onChange: (e: any) => void;
    setValue: React.Dispatch<any>;
  };

  checkVisibleModelFile: any;
  isModelFileLoadingProgress: {
    value: boolean;
    onChange: (e: boolean) => void;
    setValue: React.Dispatch<boolean>;
  };
}

function ProjectFileViewer({
  hasViewer,
  viewModelFile,
  htmlViewerRef,
  viewHtmlFile,
  viewImageFile,
  checkVisibleModelFile,
  isModelFileLoadingProgress,
}: ProjectFileViewerProps) {
  return (
    <Styled.ProjectFileViewer data-component-name="ProjectFileViewer">
      <div className="projectFileViewer__container">
        {useMemo(() => {
          return (
            <>
              {hasViewer && (
                <div className="projectFileViewer__container_item viewer">
                  <div className="projectFileViewer__viewer_box">
                    {/* <ModelViewer
                      model={viewModelFile.value}
                      isModelFileLoadingProgress={isModelFileLoadingProgress}
                      width={1237}
                      height={710}
                      className={cx('projectFileViewer__modelViewer', {
                        on: checkVisibleModelFile.size > 0,
                      })}
                    /> */}
                    <ProjectModelViewer
                      model={viewModelFile.value}
                      isModelFileLoadingProgress={isModelFileLoadingProgress}
                      width={1237}
                      height={710}
                      className={cx('projectFileViewer__modelViewer', {
                        on: checkVisibleModelFile.size > 0,
                      })}
                      onLoading={isLoading => isModelFileLoadingProgress.setValue(isLoading)}
                    />

                    <div
                      className={cx('projectFileViewer__htmlViewer', { on: !!viewHtmlFile.value })}
                    >
                      <iframe
                        ref={htmlViewerRef}
                        src=""
                        frameBorder="0"
                        title="3D model web viewer"
                      ></iframe>
                    </div>

                    <div
                      className={cx('projectFileViewer__imageViewer', {
                        on: !!viewImageFile.value,
                      })}
                    >
                      <img src={viewImageFile.value} />
                    </div>
                    {checkVisibleModelFile.size === 0 &&
                      !viewHtmlFile.value &&
                      !viewImageFile.value && (
                        <div className="projectFileViewer__viewer_help_text">
                          <T>PROJECT_SCREEN_DISPLAYED</T>
                        </div>
                      )}
                  </div>
                </div>
              )}
            </>
          );
        }, [
          hasViewer,
          viewModelFile.value,
          viewHtmlFile.value,
          viewImageFile.value,
          checkVisibleModelFile,
        ])}
      </div>
    </Styled.ProjectFileViewer>
  );
}

export default React.memo(ProjectFileViewer);

const Styled = {
  ProjectFileViewer: styled.div`
    width: 1237px;
    height: 710px;
    border-radius: 0 0 10px 0;
    overflow: hidden;
    position: relative;
    .projectFileViewer__viewer_box {
      position: relative;
      width: 1237px;
      height: 710px;

      background-color: #fbfbfb;
      overflow: hidden;
    }
    .projectFileViewer__viewer_help_text {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
      width: 100%;
      height: 710px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #d1d1d1;
      font-size: 16px;
    }

    .projectFileViewer__modelViewer {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      visibility: hidden;
      &.on {
        z-index: 10;
        visibility: visible;
      }
    }
    .projectFileViewer__htmlViewer {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      overflow: overlay;
      visibility: hidden;
      &.on {
        z-index: 10;
        visibility: visible;
      }
      &,
      iframe {
        width: 1237px;
        height: 710px;
      }
      iframe {
      }
    }
    .projectFileViewer__imageViewer {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      overflow: overlay;
      visibility: hidden;
      &.on {
        z-index: 10;
        visibility: visible;
      }
      img {
        width: 1237px;
        height: 710px;
      }
    }

    .projectFileViewer__select_partner_box {
      padding: 30px;
      border: 1px solid #e1e1e1;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .projectFileViewer__select_partner_label {
        font-size: 14px;
        font-weight: 500;
        color: #303030;
      }
      .projectFileViewer__select_partner_name {
        width: 270px;
        .projectFileViewer__select_partner {
          &.fake_box {
            width: 100%;
            height: 32px;
            border: 1px solid #e1e1e1;
            display: flex;
            align-items: center;
            padding: 0 8px;
            padding-right: 55px;
            font-size: 12px;
            border-radius: 5px;
          }
        }
      }
    }
  `,
};
